import Button from "components/common/Button";
import Loading from "components/common/Loading";
import { useHttpUtil } from "context/HttpContext";
import Stats from "libs/utils/stats";
import Tools from "libs/utils/Tools";
import { useEffect, useRef, useState } from "react"
import { useDetailContext } from "../DetailContext";
import { ActionName } from "../MockupEditor";
import CustomImage from "components/common/CustomImage";

type ProductLib = {
    id : string,
    name: string,
    url : string,
    product: boolean,
    isMore: boolean,
    sonList ?: ProductLib[]
}

// Shopify 产品
export default function Product2_0(props: { onImageClick: Function, type?: number}){
    const {type = 1, onImageClick} = props ;
    const detailContext = useDetailContext();

    const [ list, setList] = useState<ProductLib[]>([]);
    const [ showList, setShowList] = useState<ProductLib[]>();
    const [ searchList, setSearchList ]= useState<ProductLib[]>();
    const [ productList, setProductList ]= useState<ProductLib[]>([]);

    const [ isLoading, setIsLoading ]= useState<boolean>(false);
    const [ isListLoading, setIsListLoading ]= useState<boolean>(false);
    const [ isProductLoading, setIsProductLoading ]= useState<boolean>(false);

    const [isShowStyle, setIsShowStyle] = useState<boolean>(false);
    const [ currentStyle, setCurrentStyle ]= useState<ProductLib>();
    const [ keyword, setKeyword] = useState<string>();

    const [ checkedType, setCheckedType ] = useState<ProductLib>();
    const [ checkedProduct, setCheckedProduct ] = useState<ProductLib>();

    const [ modalWidth, setModalWidth] = useState<number>(1200);

    const contentElement = useRef<HTMLDivElement>(null);
    const listElement = useRef<HTMLDivElement>(null);
    const productListElement = useRef<HTMLDivElement>(null);

    const httpUtil = useHttpUtil();
    

    useEffect(() => {
        let bodyWidth = document.body.clientWidth;
        if(bodyWidth < 1280) bodyWidth += 30 ;
        contentElement.current && setModalWidth(bodyWidth - contentElement.current?.getBoundingClientRect().width - 100)
        initList();
    }, [  ])

    useEffect(() => {
        if(searchList?.length){
            if(searchList[0].sonList && searchList[0].sonList.length){
                changeProduct(searchList[0].sonList[0])
            }
        }
    }, [ searchList ])

    const initList = async () => {
        const params : any = { type }
        if(checkedType){
            params.id = checkedType.id ;
            setIsListLoading(true);
        }else{
            setIsLoading(true);
        }
        const resData = await httpUtil.post('/biz/product/plist',params);
        if(resData.errCode === 0){
            if(checkedType){
                setShowList(resData.data);
                setSearchList(resData.data);
                setIsListLoading(false);
            }else{
                setList(resData.data)
                setIsLoading(false);
            }
        }
    }

    useEffect(() => {
        setSearchList([]);
        setCurrentStyle(undefined);
        setKeyword('');
        setProductList([]);
        setCheckedProduct(undefined);
        listElement.current && listElement.current.scrollTo({
            top: 0
        })
        if(checkedType){
            initList();
        }else{
            setShowList([]);
        }
    }, [checkedType?.id])


    const changeProductType = async (p: ProductLib) => {
        setCheckedType(p)
    }

    const changeProduct = async(p: ProductLib) => {
        productListElement.current && productListElement.current.scrollTo({
            top: 0
        })

        setCheckedProduct(p);
        setIsProductLoading(true);
        const resData = await httpUtil.post('/biz/product/pdetail',{
            id : p.id
        });
        if(resData.errCode === 0){
            const _list = resData.data ;
            for(let i = 0, len = _list.length ;i < len ;i ++){
                _list[i].url = Tools.decodeUrl(_list[i].url);
            }
            setProductList(_list)
        }
        setIsProductLoading(false);
    }

    const handleKeyDown = (e: any) => {
        if(e.key == 'Enter'){
            search();
        }
    }

    const changeStyle = async (style ?: ProductLib) => {
        setCurrentStyle(style);
    }

    useEffect(() => {
        search();
    },[currentStyle])


    const search = () => {
        const _list: ProductLib[] = [];

        showList?.map((product: ProductLib) => {
            const isLib = currentStyle ? currentStyle.id === product.id : true ;
            if(isLib){
                const _product = {... product};
                let sonList: ProductLib[] = product.sonList ? [...product.sonList] : [];
                if(keyword){
                    sonList = sonList?.filter((item: ProductLib) => item.name.indexOf(keyword) > -1);
                }
                _product.sonList = sonList ;
                _product.isMore = false ;
                _list.push(_product)
            }
        })

        setSearchList(_list)
    }

    const seeAllOrHide = (index: number, flag: boolean) => {
        if(!searchList) return ;
        const _list = [...searchList];
        _list[index].isMore = flag ;
        setSearchList(_list);
    }

    
    const applyProductImages = () => {
        setCheckedType(undefined) ; // 隐藏
        const len = productList.length ;
        if(len == 1) return onImageClick(productList[0].url);
        const urls = [] ;
        for(let i = 0, len = productList.length;i < len ;i ++){
            urls.push(productList[i].url)
        }
        onImageClick(urls);

        Stats.google('Apply')
    }

    const generateMockupsByProductImages = () => {
        setCheckedType(undefined) ; // 隐藏
        const len = productList.length ;
        const urls = [] ;
        for(let i = 0, len = productList.length;i < len ;i ++){
            urls.push(productList[i].url)
        }
        detailContext?.triggerEditorAction({
            name: ActionName.GENERATE_MOCKUPS,
            params: {
                images: urls,
                folderUrl: 'https://www.mockuplabs.ai/moc',
                timeSpan: 15
            }
        });
    }


    // useEffect(() => {
    //     if(!isApplyLoading){
    //         setApplyIndex(-1);
    //         return ;
    //     }
    //     if(applyIndex > -1){
    //         const p = productList[applyIndex];
    //         onImageClick(p.url)
    //         httpUtil.post('/biz/product/click',{ productId: p.id});
    //     }
    // }, [applyIndex, isApplyLoading])

    // const applyProductImages = () => {
    //     setIsApplyLoading(true);
    //     setApplyIndex(0)
    // }
    // // 处理相关的回调
    // useEffect(() => {  
    //     const type = detailContext?.editorCallbackData?.type ;
    //     switch(type){
    //         case EventCallbackParamsType.ADD_ELEMENT_SUC_CALLBACK: // 添加元素成功后的回调
    //             const index = applyIndex + 1 ;
    //             if(index >= productList.length){
    //                 setIsApplyLoading(false);
    //                 setCheckedType(undefined) ; // 隐藏
    //             }else  setApplyIndex(index)
    //             break;
    //     }
    // },[detailContext?.editorCallbackData])


    return (
        <div className="absolute z-[10007] h-full top-[0px] shadow-lg bg-[#FFFFFF] xl:w-[320px] xl:left-[100px] w-[200px] left-[70px]" ref={contentElement}  >
            <div className="relative flex flex-col h-full w-full p-[10px] xl:p-[20px] overflow-y-auto z-[10001]  bg-[#FFFFFF]" onClick={() => setCheckedType(undefined)}>
                {
                    <p className="medium-txt font-medium">Mockup set categories</p>
                }
                
                {
                    !isLoading ?
                        <div className="grid grid-cols-2 gap-[5px] xl:gap-[10px] mt-[5px] xl:mt-[10px]">
                            {
                                list && list.map((product: ProductLib) => (
                                    <div className={`cursor-pointer border rounded-[10px] ${checkedType?.id === product.id && 'border-[#14A5FA]'}`} key={product.id} onClick={(e) => { e.stopPropagation(); changeProductType(product)}}>
                                        <div className="aspect-square flex items-center justify-center]">
                                            <CustomImage loading="lazy" src={product.url || "/no-image.png"} className={`max-w-full max-h-full rounded-t-[10px]`} />
                                        </div>
                                        {
                                            !product.product && 
                                            <div className="flex items-center p-[10px]" >
                                                <span className="font-semibold truncate small-txt">{product.name}</span>
                                            </div>
                                        }
                                    </div>
                                ))
                            }
                        </div>
                            
                    :
                        <div className="mt-[80px] text-center">
                            <Loading className="!pb-[5px]"/>
                            <p>Loading, please wait...</p>
                        </div>
                }
            </div>
            {
                checkedType ?
                    <div className="absolute left-[200px] pl-[20px] py-[20px] pr-[20px] top-[0px] xl:left-[320px] h-[100%] w-[1300px] flex gap-[20px] bg-[#000000]/[0.5]" style={{
                        width : modalWidth
                    }}>
                        <div className="w-[70%] h-full bg-[#FFFFFF] py-[5px] rounded-[10px] relative">
                            <div className="absolute top-[25px] left-[-13px] w-[25px] h-[25px] rotate-45 bg-[#FFFFFF]"></div>
                            {
                                checkedProduct && 
                                <div className="absolute top-[25px] right-[-13px] w-[25px] h-[25px] rotate-45 bg-[#FFFFFF]"></div>
                            }
                            
                            <div className="flex flex-col h-full py-[20px] px-[10px] ">
                                <div className="h-[80px] px-[5px]">
                                    <p className="text-[20px] xl:text-[24px] font-medium">All {checkedType.name}</p>
                                    <div className="flex gap-[10px] mt-[10px]">
                                        <div className="w-[200px]  p-[10px] bg-[#F6F6F6]  relative rounded-[10px] cursor-pointer"
                                                onClick={() => setIsShowStyle(!isShowStyle)}>
                                            <span className="font-bold">{currentStyle ? currentStyle.name : 'Styles'}</span>
                                            <CustomImage src={isShowStyle ? "/icon/icon-layer-down.png" : "/icon/icon-layer-right.png"} className="absolute right-[15px] top-[9px] w-[20px]"/>
                                            {
                                                isShowStyle && 
                                                <div className="absolute left-[0] top-[42px] w-[100%] rounded-[5px] overflow-hidden shadow-box">
                                                    <p className="bg-[#D9F2FF] py-[10px] px-[10px] cursor-pointer" onClick={() => changeStyle(undefined)}>All</p>
                                                    {
                                                        showList && showList.map((product: ProductLib) => (
                                                            <p key={product.id} className="bg-[#FFFFFF] py-[10px] px-[10px] cursor-pointer" onClick={() => changeStyle(product)}>{ product.name }</p>
                                                        ))
                                                    }
                                                    
                                                </div>
                                            }
                                        </div>
                                        <div className="flex items-center relative">
                                            <input type="text" placeholder="Search for mockups" 
                                                className="py-[8px] xl:py-[10px] pr-[15px] pl-[35px] xl:pl-[45px] border focus:border-[#14A5FA] w-[300px] xl:w-[400px] outline-none rounded-[10px] "
                                                value={keyword} 
                                                onChange={(e) => setKeyword(e.target.value)}
                                                onKeyDown={handleKeyDown}/>
                                            <CustomImage src="/icon/icon-search.png" className="absolute left-[10px] xl:left-[15px] top-[50%] translate-y-[-10px] w-[20px] h-[20px]" />
                                        </div>
                                    </div>
                                </div>
                                {
                                    isListLoading ? 
                                        <div className="mt-[80px] text-center">
                                            <Loading className="!pb-[5px]"/>
                                            <p>Loading, please wait...</p>
                                        </div>
                                    : 
                                    <div className="mt-[20px] pb-[15px] grow overflow-y-auto px-[5px]" ref={listElement}>
                                        {
                                            searchList && searchList.map((product: ProductLib,index: number) => (
                                                <div className="mt-[20px] first:mt-[0]" key={product.id}>
                                                    <p className="text-[16px] font-medium">{ product.name }</p>
                                                    <div className="grid grid-cols-4 gap-[15px] mt-[10px]">
                                                        {
                                                            product.sonList && product.sonList.map((sproduct: ProductLib, sindex: number) => (
                                                                product.isMore || !product.isMore && sindex < 12 ?
                                                                    <div className={`cursor-pointer border rounded-[10px] ${sproduct.id === checkedProduct?.id && 'border-[#14A5FA]'}`} 
                                                                        key={sproduct.id} onClick={(e) => { e.stopPropagation(); changeProduct(sproduct)}}>
                                                                        <div className="aspect-square flex items-center justify-center]">
                                                                            <CustomImage loading="lazy" src={sproduct.url || "/no-image.png"} className={`w-full h-full rounded-[10px]`} />
                                                                        </div>
                                                                        {
                                                                            // <div className="flex items-center p-[10px]" >
                                                                            //     <span className="truncate small-txt" title={sproduct.name}>{sproduct.name}</span>
                                                                            // </div>
                                                                        }
                                                                    </div>
                                                                : null
                                                            ))
                                                        }
                                                    </div>
                                                    {
                                                        product.sonList && product.sonList?.length > 12 ?
                                                            product.isMore ?
                                                            <p className="medium-txt text-center underline underline-offset-4 font-medium cursor-pointer mt-[15px]"
                                                                onClick={() => seeAllOrHide(index, false)}>Put Away</p> 
                                                            :
                                                            <p className="medium-txt text-center underline underline-offset-4 font-medium cursor-pointer mt-[15px]"
                                                                onClick={() => seeAllOrHide(index, true)}>See All</p>
                                                        : null
                                                    }
                                                </div>
                                            ))
                                        }

                                    </div>
                                }
                            </div>
                        </div>
                        {
                            checkedProduct && 
                            <div className="w-[28%] bg-[#FFFFFF] py-[15px] px-[10px] pb-[80px] rounded-[10px] relative flex flex-col overflow-y-auto">
                                <p className="medium-txt">{ checkedProduct?.name }</p>
                                <div className="grow overflow-y-auto px-[5px]">
                                    <div className="grid grid-cols-2 gap-[10px] mt-[10px]" ref={productListElement}>
                                        {
                                            productList && productList.map((product: ProductLib) => (
                                                <div key={product.id} >
                                                    <div className="aspect-square flex items-center border justify-center bg-[#D9D9D9]  rounded-[12px]">
                                                        <CustomImage loading="lazy" src={product.url || "/no-image.png"} className={`max-w-full max-h-full rounded-[10px]`} />
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                                <div className="absolute left-0 bottom-[20px] px-[15px] w-full flex gap-[5px]">
                                    <Button txt="Apply" clickEvent={applyProductImages} className="w-full py-[10px] justify-center" />
                                    {/* <Button txt="Mockups" clickEvent={generateMockupsByProductImages} className="w-full py-[10px] justify-center" /> */}
                                </div>
                            </div>
                        }
                    </div>
                : null
            }
        </div>
    )
}